module.exports = __webpack_public_path__ + "img/1.c6062d91.jpg";